import React, { useContext, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/store';
import { ChatBotContext } from '../context/ChatBotContext';
import { getDailyCheckInStatus } from '../api/checkin';
import { useQuery } from '@tanstack/react-query';
const Hero = () => {
    const auth = useRef(useAuthStore(store => store.isAuth));
    const uid = useAuthStore(store => store.user?.uid);
    const navigate = useNavigate();
    const { setShow } = useContext(ChatBotContext);

    const dailyCheckInStatusQuery = useQuery({
        queryKey: ['dailyCheckInStatus', uid],
        queryFn: () => getDailyCheckInStatus(uid),
        enabled: !(uid === null || uid === undefined),
    });

    useEffect(() => {
        setTimeout(() => {
            if (dailyCheckInStatusQuery.data === undefined) {
                return; // for the users that are not logged in but visit the '/'.
            }

            if (auth && (!dailyCheckInStatusQuery.data)) {
                // open window if checkIn has not been done.
                setShow(true);
            }
        }, 1000);
    }, [dailyCheckInStatusQuery.data]);

    const infoCards = [
        {
            title: 'Customized Avatar',
            src: '/images/avatar.png',
            alt: 'avatar',
        },
        {
            title: 'Mood Tracking',
            src: '/images/mood.png',
            alt: 'mood-timeline',
        },
        {
            title: 'Individualized Feedback',
            src: '/images/lightbulb.png',
            alt: 'lighbulb',
        },
    ];

    return (
        <div className='hero'>
            <section className='flex flex-col lg:flex-row-reverse xl:flex-row-reverse items-center justify-between gap-4 py-8 px-16 lg:py-24 xl:py-24 lg:px-32 xl:px-32'>
                <div className='flex flex-1 justify-center'>
                    <img className='w-[200px] h-[200px] lg:w-full xl:w-full lg:h-full xl:h-full' src={process.env.PUBLIC_URL + '/worker.svg'} alt='Description' />
                </div>
                <div className='flex flex-1 flex-col items-center gap-8'>
                    <h1 className='text-4xl text-black font-medium text-center'>Your Customized Wellness Buddy</h1>
                    <p className='px-6 text-base text-black text-center'>
                        Measure your mental health and wellness with data-driven insights and
                        personalized feedback
                    </p>
                    {auth
                        ? (
                            <button
                                className='w-38 px-4 py-3 text-base font-inherit rounded-2xl border-none outline-none cursor-pointer bg-[rgb(243,146,0)] text-white'
                                onClick={() => navigate('/profile')}
                            >
                            View Profile
                            </button>
                        )
                        : (
                            <button
                                className='w-38 px-4 py-3 text-base font-inherit rounded-2xl border-none outline-none cursor-pointer bg-[rgb(243,146,0)] text-white'
                                onClick={() => navigate('/register')}
                            >
                            Get Started
                            </button>
                        )}
                </div>
            </section>
            <section className='flex flex-col lg:flex-row xl:flex-row justify-center items-center gap-10 p-12 lg:px-20 xl:px-20 lg:py-32 xl:py-32 bg-[#d0e5ed]'>
                {infoCards.map((card, index) => {
                    return (
                        <div key={index} className='flex flex-1 flex-col items-center gap-12'>
                            <img src={card.src} alt={card.alt} className='h-[60px]'/>
                            <h3 className='text-2xl text-black font-medium text-center'>{card.title}</h3>
                        </div>
                    );
                })}
            </section>
        </div>
    );
};

export default Hero;
